import type { CountryConfig } from '../types';

export const PAKISTAN_CONFIG: CountryConfig = {
    currencyCode: 'PKR',
    currencySuffix: 'PKR',
    phoneCountryCode: '+92',
    phoneCountryLabel: 'Pakistan (+92)',
    whatsappSupportNumber: '+92 3XX XXXXXXX', // existing hardcoded placeholder, unchanged
    septaBankName: 'PLACEHOLDER BANK NAME',
    septaAccountName: 'PLACEHOLDER ACCOUNT NAME',
    septaAccountNumber: 'PLACEHOLDER-0000-0000',
    usesCombinedRanking: false,
    ordersClassesByTier: false,
    excludesSelectiveSubjects: false,
    usesTermUploadReports: false,
    usesElementBasedReports: false,
    usesCustomAssessmentTypes: false,
    usesSelectiveStudentPicker: false,
    usesBranchGroupTargeting: false,
    usesAssessmentComponents: false,
    usesLocalizedCurrencyFormat: false,
    usesNigerianClassDefaults: false,
    usesCustomTimetableEntries: false,
    usesExamEventTermDates: false,
    usesActiveRosterInRankings: false,
    usesAttendanceBackfill: false,
    usesAssessmentTerminology: false,
    usesStaffRolesSearch: false,
    usesDeferredBaseFee: false,
};
